import { Syringe, singleton, contrib } from '@alipay/mana-syringe';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

var LanguageWorkerContribution = Syringe.defineToken('LanguageWorkerContribution');
var LanguageWorkerRegistry = /*#__PURE__*/function () {
  function LanguageWorkerRegistry(provider) {
    var _this = this;
    _classCallCheck(this, LanguageWorkerRegistry);
    this.provider = void 0;
    this.configs = [];
    this.provider = provider;
    // TODO: 所有扩展点应该有一个上层的运行时生命期管理机制，每个扩展点都应该声明自己需要在什么运行时被初始化
    this.provider.getContributions().forEach(function (contribution) {
      contribution.registerLanguageWorkers(_this);
    });
  }
  _createClass(LanguageWorkerRegistry, [{
    key: "registerWorker",
    value: function registerWorker(config) {
      var conf = _objectSpread2(_objectSpread2({}, config), {}, {
        language: config.language.toUpperCase()
      });
      if (this.configs.find(function (c) {
        return c.language === conf.language;
      })) {
        console.warn("Language ".concat(conf.language, " has already registed, this will overwrite the previous configuration"));
      }
      this.configs = [].concat(_toConsumableArray(this.configs), [conf]).sort(function (a, b) {
        var aPriority = a.priority || 100;
        var bPriority = b.priority || 100;
        return bPriority - aPriority;
      });
    }
  }, {
    key: "getLanguageWorker",
    value: function getLanguageWorker(language, moduleId) {
      var config = this.getLanguageConfig(language);
      if (config) {
        return config.getWorkerUrl(language, moduleId);
      }
      return undefined;
    }
  }, {
    key: "getLanguageConfig",
    value: function getLanguageConfig(language) {
      return this.configs.find(function (item) {
        return item.language.toUpperCase() === language.toUpperCase();
      });
    }
  }]);
  return LanguageWorkerRegistry;
}();
LanguageWorkerRegistry = __decorate([singleton(), __param(0, contrib(LanguageWorkerContribution)), __metadata("design:paramtypes", [Object])], LanguageWorkerRegistry);

var LanguageOptionsRegistry = /*#__PURE__*/function () {
  function LanguageOptionsRegistry() {
    _classCallCheck(this, LanguageOptionsRegistry);
    this.optionsMap = new Map();
  }
  _createClass(LanguageOptionsRegistry, [{
    key: "registerOptions",
    value: function registerOptions(key, data) {
      this.optionsMap.set(key, data);
    }
  }, {
    key: "getOptions",
    value: function getOptions(key) {
      return this.optionsMap.get(key);
    }
  }]);
  return LanguageOptionsRegistry;
}();
LanguageOptionsRegistry = __decorate([singleton()], LanguageOptionsRegistry);

var EditorHandlerContribution = Syringe.defineToken('LanguageWorkerContribution');

export { EditorHandlerContribution, LanguageOptionsRegistry, LanguageWorkerContribution, LanguageWorkerRegistry };
